import React, {useEffect, useState} from 'react'
import Image from "next/image";

interface AuthenticatedImageProps {
  imageUrl: string
  authToken: string
  alt: string
  width?: number
  height?: number
  objectFit?: string
  fill?: boolean
}

const AuthenticatedImage = ({imageUrl, authToken, fill, objectFit, alt, width, height}: AuthenticatedImageProps) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchImage = async () => {
      try {
        // Effettua il fetch dell'immagine con l'header Authorization
        const response = await fetch(imageUrl, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })

        if (!response.ok) {
          throw new Error(`Errore ${response.status}: Impossibile caricare l'immagine`)
        }

        const blob = await response.blob()
        const imageObjectURL = URL.createObjectURL(blob)

        setImageSrc(imageObjectURL)
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message)
        } else {
          setError('Errore sconosciuto durante il caricamento dell\'immagine')
        }
      }
    }

    fetchImage()
  }, [imageUrl, authToken])

  if (error) {
    return <p>{`Errore nel caricamento dell'immagine: ${error}`}</p>
  }

  return (
    <>
      {imageSrc ? (
        <Image width={width} unoptimized height={height} objectFit={objectFit} alt={alt} fill={fill} src={imageSrc}/>
      ) : (
        <p>Caricamento in corso...</p>
      )}
    </>
  )
}

export default AuthenticatedImage
